
import React from 'react';
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const FontDisplay = () => {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        <section className="py-16 md:py-24">
          <div className="container-custom">
            <div className="max-w-5xl mx-auto">
              <h1 className="interview-title mb-12 text-rainbow text-center">
                INTERVIEW MAG
              </h1>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24">
                <div className="space-y-12">
                  <div className="border-b-4 border-black pb-6">
                    <h2 className="font-interview text-4xl uppercase tracking-tighter mb-6">Bodoni Moda</h2>
                    <p className="font-interview text-7xl mb-8 text-rainbow">
                      Aa Bb Cc
                    </p>
                    <p className="font-interview text-5xl mb-6 text-rainbow">
                      0123456789
                    </p>
                    <p className="font-interview text-4xl mb-6 text-rainbow">
                      !@#$%^&*()
                    </p>
                  </div>
                  
                  <div className="mt-8">
                    <h3 className="font-interview text-3xl uppercase mb-4">Editorial Style</h3>
                    <p className="font-interview text-3xl leading-tight mb-6">
                      "The quick brown fox jumps over the lazy dog."
                    </p>
                    <p className="font-interview text-3xl italic leading-tight">
                      <span className="text-5xl mr-1">"</span>How vexingly quick daft zebras jump!<span className="text-5xl ml-1">"</span>
                    </p>
                  </div>
                </div>
                
                <div className="space-y-12">
                  <div className="border-b-4 border-black pb-6">
                    <h2 className="font-interview-sans text-4xl uppercase tracking-tighter mb-6">Montserrat</h2>
                    <p className="font-interview-sans text-7xl font-black mb-8 text-rainbow">
                      Aa Bb Cc
                    </p>
                    <p className="font-interview-sans text-5xl font-black mb-6 text-rainbow">
                      0123456789
                    </p>
                    <p className="font-interview-sans text-4xl font-black mb-6 text-rainbow">
                      !@#$%^&*()
                    </p>
                  </div>
                  
                  <div className="mt-8">
                    <h3 className="font-interview-sans text-3xl uppercase font-bold mb-4">Modern Sans</h3>
                    <p className="font-interview-sans text-3xl font-light leading-tight mb-6">
                      "The quick brown fox jumps over the lazy dog."
                    </p>
                    <p className="font-interview-sans text-3xl font-bold leading-tight">
                      <span className="text-5xl mr-1">"</span>Pack my box with five dozen liquor jugs.<span className="text-5xl ml-1">"</span>
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="mt-16 text-center">
                <Button className="interview-btn text-2xl px-12 py-6">
                  USE THESE FONTS
                </Button>
              </div>
              
              <div className="mt-24 border-t-8 border-black pt-12">
                <h2 className="interview-title text-center mb-12">TYPOGRAPHY</h2>
                <div className="grid grid-cols-1 gap-6">
                  <div className="overflow-x-auto">
                    <p className="font-interview text-9xl uppercase text-rainbow whitespace-nowrap">ABCDEFGHIJKLMNOPQRSTUVWXYZ</p>
                  </div>
                  <div className="overflow-x-auto">
                    <p className="font-interview text-8xl text-rainbow whitespace-nowrap">abcdefghijklmnopqrstuvwxyz</p>
                  </div>
                  <div className="overflow-x-auto">
                    <p className="font-interview-sans text-8xl font-black uppercase text-rainbow whitespace-nowrap">ABCDEFGHIJKLMNOPQRSTUVWXYZ</p>
                  </div>
                  <div className="overflow-x-auto">
                    <p className="font-interview-sans text-7xl font-black text-rainbow whitespace-nowrap">abcdefghijklmnopqrstuvwxyz</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default FontDisplay;
